import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import LazyImg from 'components/LazyImg';
import './index.scss';
@inject(({store}) => ({
    data: store.ymbj
}))
@observer
class ModuleTitle extends React.Component {
    render() {
        const {name, data} = this.props;
        if(!name || !data[name]) return null;
        let img = '';
        if(Array.isArray(toJS(data[name]))) {
            img = data[name][0] && data[name][0].bg;
        }else{
            img = data[name] ? data[name].bg : '';
        }
        return (
            <LazyImg scrollContainer="#container">
                <div className="module-tit tit"><img src={img}/></div>
            </LazyImg>
        );
    }
}

export default ModuleTitle;